import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import AmpArrowTooltip from "../../common/AmpArrowTooltip/AmpArrowTooltip";
import { setToastNotification } from "../../../redux/actions/toastNotification/toastNotification";

import "./Steps.css";

interface RfrUploadFilesProps {
    name: string,
    maxFiles: number,
    maxSizeTotal: number,
    // maxSizePerFile: number,
    maxSizeLabelKey: string,
    allowedTypes: string,
    onInput: (e) => void,
    desc?: string,
    files: Array<unknown>,
    setFiles: (e) => void,
    disabled?: boolean | false
}

export default function RfrUploadFiles(props: RfrUploadFilesProps) {
    const { t } = useTranslation("rfr");
    const dispatch = useDispatch();
    const allowedTypes = props.allowedTypes.split(',').map(type => type.trim());
    const tooltipItems = [
        t("rfr.rfrform.maximum") + " " + props.maxFiles + " " + t("rfr.rfrform.files"),
        t("rfr.rfrform.maximum") + " " + t(props.maxSizeLabelKey) + " " + t("rfr.rfrform.in-total"),
        t("rfr.rfrform.allowed-types") + " " + props.allowedTypes
    ];

    const convertBase64 = (file: File, cb) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const dispatchToastNotification = (msg) => {
        dispatch(setToastNotification(msg, "error"));
        setTimeout(() => {
            dispatch(setToastNotification(null, "error"));
        }, 500);
    }

    const handleFileEvent = (e) => {
        dispatch(setToastNotification(null, "error"));
        const targetfile = Array.prototype.slice.call(e.target.files)[0];
        const files = [
            ...props.files
        ];
        if (files.length >= props.maxFiles) {
            const msg = t("rfr.rfrform.file-exceeds-max-1") + props.maxFiles + t("rfr.rfrform.file-exceeds-max-2");
            dispatchToastNotification(msg);
            return;
        }
        // if (targetfile.size > props.maxSizePerFile) {
        //     const msg = t("rfr.rfrform.file-exceeds-max-size") + t(props.maxSizeLabelKey) + ".";
        //     dispatchToastNotification(msg);
        //     return;
        // }
        const filename = targetfile.name;
        const extidx = filename.lastIndexOf(".");
        const ext = filename.substring(extidx);
        if (!allowedTypes.includes(ext)) {
            const msg = t("rfr.rfrform.file-not-allowed") + props.allowedTypes + ".";
            dispatchToastNotification(msg);
            return;
        }

        let totalSize = 0;
        for (let i = 0; i < files.length; i++) {
            if (filename === files[i].name) {
                const msg = t("rfr.rfrform.file-exists");
                dispatchToastNotification(msg);
                return;
            }
            totalSize = totalSize + files[i].size;
        }

        totalSize = totalSize + targetfile.size;
        if (totalSize > props.maxSizeTotal) {
            const msg = t("rfr.rfrform.file-exceeds-max-size") + t(props.maxSizeLabelKey) + " " + t("rfr.rfrform.in-total") + ".";
            dispatchToastNotification(msg);
            return;
        }

        convertBase64(targetfile, (result) => {
            files.push({ name: targetfile.name, size: targetfile.size, type: targetfile.type, file: result });
            props.setFiles(files);
        });
    }

    const handleRemove = (e, index: number) => {
        e.preventDefault();
        const files = [
            ...props.files,
        ];
        files.splice(index, 1);
        props.setFiles(files);
    }

    return (
        <>
            <AmpArrowTooltip title={t("rfr.rfrform.upload-guide")} items={tooltipItems} />
            <div className="rfr-row-extra-padding rfr-row-with-tooltipp">
                <div>
                    <div className="rfr-form-row" id="step11RepOtherFile">
                        <div className="upload-filebtn-wrapper">
                            <div id="step11RepOtherFileInputButton" className="filebtn">{t("rfr.rfrform.attach-files")}</div>
                            <input onChange={(e) => handleFileEvent(e)} type="file" name={props.name + "[]"} id={props.name} title={t("rfr.rfrform.choose-a-file")} accept={props.allowedTypes} disabled={props.disabled} />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        {props.desc}
                    </div>
                    <div className="rfr-form-row">
                        <div id={props.name + "List"}>
                            {
                                props.files.map((file, key) => {
                                    return <div key={key}>
                                        <Link onClick={(e) => handleRemove(e, key)} to={""} >
                                            <FontAwesomeIcon icon={faTrashCan} className="rfr-form-img-removefile" />
                                        </Link>
                                        <span>
                                            {file.name}
                                        </span>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
